import { ListItem, UnorderedList } from '@chakra-ui/react';
import { formatDistanceToNow, parseISO } from 'date-fns';

export function AccessIssueProblemList({
    problems,
}: {
    problems: { createdAt: string; publicName: string }[];
}) {
    return (
        <UnorderedList color="muted.700" fontSize="small">
            {problems.map((problem, idx: number) => (
            // eslint-disable-next-line react/no-array-index-key
                <ListItem key={`problem-${idx}`}>
                    {problem?.publicName}
                    {` - notified ${formatDistanceToNow(parseISO(problem.createdAt), { addSuffix: true })}`}
                </ListItem>
            ))}
        </UnorderedList>
    );
}
